
export default {
  props: {
    resource: {
      required: true
    }
  },
  computed: {
    type: function type() {
      if (this.playing) {
        return 'pause_circle';
      }
      return 'play_circle';
    }
  },
  data: function data() {
    return {
      playing: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.audioPlayer && this.audioPlayer.pause();
    this.audioPlayer && (this.audioPlayer.currentTime = 0.0);
  },

  methods: {
    createAudio: function createAudio() {
      var _this = this;

      var audio = this.audioPlayer = document.createElement('audio');
      audio.src = this.resource.file_url;
      audio.addEventListener('ended', this.end);
      this.$once('hook:beforeDestory', function () {
        audio.removeEventListener('ended', _this.end);
      });
    },
    toggle: function toggle() {
      var _this2 = this;

      if (!this.audioPlayer) this.createAudio();
      setTimeout(function () {
        if (_this2.playing) {
          _this2.pause();
        } else {
          _this2.play();
        }
      });
    },
    pause: function pause() {
      this.audioPlayer && this.audioPlayer.pause();
      this.audioPlayer && (this.audioPlayer.currentTime = 0.0);
      this.playing = false;
    },
    play: function play() {
      var _this3 = this;

      this.$emit('play', function () {
        setTimeout(function () {
          _this3.audioPlayer && _this3.audioPlayer.play();
          _this3.playing = true;
        }, 0);
      });
    },
    end: function end() {
      this.playing = false;
    }
  }
};